import * as e from "react";
import { Provider as t, useAuthenticator as s } from "./hooks/useAuthenticator/index.js";
import { CustomComponentsContext as o } from "./hooks/useCustomComponents/index.js";
import "../../primitives/View/View.js";
import { Router as r } from "./Router/Router.js";
import { SetupTOTP as i } from "./SetupTOTP/SetupTOTP.js";
import { SignIn as n } from "./SignIn/SignIn.js";
import { SignUp as m } from "./SignUp/SignUp.js";
import { ForceNewPassword as a } from "./ForceNewPassword/ForceNewPassword.js";
import "./ResetPassword/ConfirmResetPassword.js";
import { ResetPassword as u } from "./ResetPassword/ResetPassword.js";
import { defaultComponents as c } from "./hooks/useCustomComponents/defaultComponents.js";

function p(_ref) {
  var t = _ref.children,
      i = _ref.className,
      n = _ref.components,
      m = _ref.formFields,
      a = _ref.hideSignUp,
      u = _ref.initialState,
      p = _ref.loginMechanisms,
      l = _ref.signUpAttributes,
      d = _ref.services,
      f = _ref.socialProviders,
      g = _ref.variation;

  var _s = s(function (_ref2) {
    var e = _ref2.route,
        t = _ref2.signOut,
        s = _ref2.user;
    return [e, t, s];
  }),
      P = _s.route,
      j = _s.signOut,
      w = _s.user;

  !function (t) {
    var _s2 = s(function (_ref3) {
      var e = _ref3.route;
      return [e];
    }),
        o = _s2._send,
        r = _s2.route,
        i = e.useRef(!1);

    e.useEffect(function () {
      i.current || "setup" !== r || (o({
        type: "INIT",
        data: t
      }), i.current = !0);
    }, [o, r, t]);
  }({
    initialState: u,
    loginMechanisms: p,
    services: d,
    signUpAttributes: l,
    socialProviders: f,
    formFields: m
  });
  var S = e.useMemo(function () {
    return {
      components: Object.assign(Object.assign({}, c), n)
    };
  }, [n]);
  return "authenticated" === P || "signOut" === P ? t ? e.createElement(e.Fragment, null, "function" == typeof t ? t({
    signOut: j,
    user: w
  }) : t) : null : e.createElement(o.Provider, {
    value: S
  }, e.createElement(r, {
    className: i,
    hideSignUp: a,
    variation: g
  }));
}

function l(s) {
  return e.createElement(t, null, e.createElement(p, Object.assign({}, s)));
}

l.Provider = t, l.ResetPassword = u, l.SetupTOTP = i, l.SignIn = n, l.SignUp = m, l.ForceNewPassword = a;
export { l as Authenticator, p as AuthenticatorInternal };